/* global Office, module, require */
import App from "./components/App";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ThemeProvider } from "@fluentui/react";
import * as React from "react";
import { createRoot } from "react-dom/client";

import { AppContextProvider } from "./context/AppContext";
import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";

initializeIcons();

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const config = {
  auth: { clientId: "ff5cc66a-5eac-4328-b68e-04d0a6016c1c" },
  cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
};
export const msal = new PublicClientApplication(config);

let isOfficeInitialized = false;

const title = "Midthaug priskalkulator";

// const render = (Component: FC<{ title: string; isOfficeInitialized: boolean }>) =>{

//     return
// }

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;

  root?.render(
    <ThemeProvider>
      <AppContextProvider>
        <App title={title} isOfficeInitialized={isOfficeInitialized} />
      </AppContextProvider>
    </ThemeProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
